import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const adminToken = {
  get: () => localStorage.getItem("mqs_admin_token"),
  set: (t) => localStorage.setItem("mqs_admin_token", t),
  clear: () => localStorage.removeItem("mqs_admin_token"),
  name: () => localStorage.getItem("mqs_admin_name") || "",
  setName: (n) => localStorage.setItem("mqs_admin_name", n),
};

export const api = axios.create({ baseURL: API });

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = adminToken.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
